import React from 'react';

const Privacy = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-center text-white mb-12">
        Adatvédelmi Nyilatkozat
      </h1>

      <div className="max-w-4xl mx-auto bg-gray-800 rounded-xl p-8 shadow-lg">
        <div className="prose prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              1. Általános információk
            </h2>
            <p className="text-gray-300 mb-4">
              A Webforyou Kft. (továbbiakban: Adatkezelő) tiszteletben tartja az Ön személyes adatait és elkötelezett azok védelme iránt. 
              Jelen adatvédelmi nyilatkozat tájékoztatást nyújt arról, hogy milyen adatokat gyűjtünk és hogyan 
              használjuk azokat.
            </p>
            <div className="bg-gray-700 p-4 rounded-lg">
              <h3 className="text-lg font-medium text-white mb-2">Adatkezelő adatai:</h3>
              <ul className="text-gray-300 space-y-1">
                <li>Cégnév: Webforyou Kft.</li>
                <li>Székhely: 4400 Nyíregyháza, Tokaji út 37/F</li>
                <li>Adószám: 29146699-2-15</li>
                <li>Email: support@webforyou.hu</li>
                <li>Telefon: +36 70 908 3086</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              2. Személyes adatok kezelése
            </h2>
            <p className="text-gray-300 mb-4">
              Az alábbi személyes adatokat gyűjtjük és kezeljük:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>Név</li>
              <li>Email cím</li>
              <li>Telefonszám (opcionális)</li>
              <li>Üzenet tartalma</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              3. Az adatkezelés célja
            </h2>
            <p className="text-gray-300 mb-4">
              Személyes adatait az alábbi célokra használjuk:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>Kapcsolattartás és kommunikáció</li>
              <li>Szolgáltatásainkkal kapcsolatos információk nyújtása</li>
              <li>Szerződéses kötelezettségek teljesítése</li>
              <li>Ügyfélszolgálati tevékenység</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              4. Adatbiztonság
            </h2>
            <p className="text-gray-300">
              Megfelelő technikai és szervezési intézkedéseket alkalmazunk az Ön személyes adatainak 
              védelmére. Rendszereinket rendszeresen teszteljük és frissítjük a biztonság fenntartása 
              érdekében.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              5. Az Ön jogai
            </h2>
            <p className="text-gray-300 mb-4">
              Az adatvédelmi jogszabályok értelmében Önt az alábbi jogok illetik meg:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>Hozzáférési jog</li>
              <li>Helyesbítéshez való jog</li>
              <li>Törléshez való jog</li>
              <li>Adatkezelés korlátozásához való jog</li>
              <li>Adathordozhatósághoz való jog</li>
              <li>Tiltakozáshoz való jog</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              6. Kapcsolat
            </h2>
            <p className="text-gray-300">
              Adatvédelemmel kapcsolatos kérdéseivel forduljon a Webforyou Kft.-hez az alábbi 
              elérhetőségeken: <a href="mailto:support@webforyou.hu" className="text-purple-400 hover:text-purple-300">
              support@webforyou.hu</a> vagy <a href="tel:+36709083086" className="text-purple-400 hover:text-purple-300">
              +36 70 908 3086</a>
            </p>
          </section>

          <section className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-sm text-gray-400">
              Utolsó módosítás: {new Date().toLocaleDateString('hu-HU')}
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default Privacy; 